/**
 * B2B product page helpers.
 * - <b2b-product-gallery>: thumbnail → main image switcher, follows variant featured media.
 * - <b2b-buy-as>: "Single pcs / Box of N" toggle that sets the quantity step for products
 *   without a quantity rule (box size from a metafield).
 */

if (!customElements.get('b2b-product-gallery')) {
  customElements.define(
    'b2b-product-gallery',
    class B2BProductGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll('.b2b-gallery__thumb'));
        this.slides = Array.from(this.querySelectorAll('.b2b-gallery__slide'));

        this.thumbs.forEach((thumb) =>
          thumb.addEventListener('click', () => this.setActiveMedia(thumb.dataset.mediaId))
        );

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data?.sectionId !== this.dataset.section) return;
            const mediaId = data.variant?.featured_media?.id;
            if (mediaId) this.setActiveMedia(String(mediaId));
          });
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      setActiveMedia(mediaId) {
        if (!this.slides.some((slide) => slide.dataset.mediaId === mediaId)) return;

        this.slides.forEach((slide) => {
          slide.hidden = slide.dataset.mediaId !== mediaId;
        });
        this.thumbs.forEach((thumb) => {
          if (thumb.dataset.mediaId === mediaId) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}

if (!customElements.get('b2b-buy-as')) {
  customElements.define(
    'b2b-buy-as',
    class B2BBuyAs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-step]'));
        this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button)));
      }

      get quantityInput() {
        return this.closest('product-info')?.querySelector('.quantity__input');
      }

      select(button) {
        this.buttons.forEach((item) => item.setAttribute('aria-checked', String(item === button)));

        const input = this.quantityInput;
        if (!input) return;

        const step = parseInt(button.dataset.step, 10) || 1;
        input.step = step;
        input.min = step;
        input.dataset.min = step;
        input.value = step;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
